let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3693X"), load("45qFt"), load("i9Xyo")]).then(() => parcelRequire('jkQop'));